import useBottomSheet from 'hooks/common/useBottomSheet';
import Button from 'components/common/Button';

function AlertPermissionSheet() {
    const { closeWithAnimation, sheets } = useBottomSheet();

    const handleEventNotiCheckBoxOn = () => {
        Device.setNotificationByKey('event', 'on', true);
        Device.setNotificationByKey('nightnoti', 'on', true);

        CommonUI.showToast(document.getElementById('hMainContainer'), { text: `${brsc.noti_setting_complete}`, position: 'top'});
    };

    const recordNotificationPermission = () => {
        ba('notification-permission-popup', undefined, {
            action: 'accept',
            popup: sheets.id,
            actionType: 'clicked-permission',
            fbUid: myinfo.fbUid,
            country: myinfo.country,
            gender: myinfo.gender,
            device: Device.name,
        });
    };

    const handleConfirm = () => {
        handleEventNotiCheckBoxOn();
        recordNotificationPermission();
        closeWithAnimation('AlertPermissionSheet');
    };

  return (
    <>
    <div className="flex flex-col w-full rounded-t-lg bg-dialog-bg-default">
        {/** 텍스트 컨테이너 */}
        <div className='flex flex-col w-full items-center gap-[var(--spacing-md)]'>
            <p className='self-stretch text-center typography-title-md not-italic text-dialog-txt-default m-0'>{brsc.noti_setting_title}</p>
            <p className='self-stretch text-center text-dialog-txt-secondary typography-body-sm not-italic m-0'>{brsc.noti_setting_body_1}</p>
        </div>
        {/** 이미지 컨테이너 */}
        <div className='flex justify-center'>
            <img className="w-[240px] h-[240px] aspect-square" alt="coin-promotion" src="/imgweb/event/coin_promotion.png" />
        </div>
        {/** 설명 텍스트 */}
        <p className='mt-[8px] mb-[12px] text-dialog-txt-secondary typography-caption-body text-center not-italic m-0'>{brsc.noti_setting_body_2}</p>
        {/** 버튼 */}
        <Button style={{ text: `${brsc.noti_accept_btn}`, color: 'btn-bg-primary', fontColor: 'btn-txt-primary', borderRadius: 'lg' }} onClick={handleConfirm} />
    </div>
    <div className='h-[34px]'/>
    </>
  );
}

export default AlertPermissionSheet;